import MenuItem from '@mui/material/MenuItem';
import { Menu as MuiMenu } from '@mui/material';
import { MenuProps } from './Menu.props';

export const Menu = ({ children, ...props }: MenuProps) => {
  return <MuiMenu {...props}>{children}</MuiMenu>;
};

export { MenuItem };

export default Menu;
